/* ShinePod R4 — modular Ascendify/Shrine sections runtime.
   Rewritten from the handover's r4.js: document-scoped, null-guarded, single init guard.
   The internal review layer (storageKey/exportFeedback/goToPillar/setReviewNotes/openSources/
   sourceSummary/#open-sources/feedback panels) has been removed. The review-only purchase toast
   is replaced with a real cart-drawer flow. All offer data is read from the DOM (data-* on the
   pack radios) so editing settings in the theme editor is never overwritten by JS. */
(function () {
  if (window.__spR4Init) return;
  window.__spR4Init = true;

  /* ============================================================
     CART INTEGRATION — edit this block for your Shrine Pro build.
     Shrine Pro is Dawn-based, so the Dawn <cart-drawer> + Sections API
     defaults below work out of the box on a standard install. If your
     theme renamed the drawer element or cart sections, adjust here.
     ============================================================ */
  var SP_CART = {
    sections: ['cart-drawer', 'cart-icon-bubble'], // section ids requested from /cart/add.js
    drawerSelector: 'cart-drawer',                 // custom element that exposes renderContents()
    notificationSelector: 'cart-notification',     // Dawn fallback when the theme uses a notification
    // clicked (in order) only if neither element above can render the drawer:
    openFallbacks: ['#cart-icon-bubble', '.header__icon--cart', '[data-cart-drawer-toggle]', 'a[href="/cart"]'],
    // theme's own count bubble(s) — watched so our header badge re-syncs on theme-side changes:
    themeCountSelectors: ['#cart-icon-bubble .cart-count-bubble span', '.cart-count-bubble span[aria-hidden]', '[data-cart-count]', '.cart-count']
  };

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (v) { var n = parseFloat(v); return isNaN(n) ? ('$' + v) : ('$' + n.toFixed(2)); };
  var fmtInt = function (v) { var n = parseFloat(v); return isNaN(n) ? v : Math.round(n).toLocaleString('en-US'); };
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- OFFERS: one shared state across both buy boxes ---------- */
    var offers = $$('.offer');
    var glance = $('.mobile-offer-glance');
    var sticky = $('.sticky-offer');

    function selectedInput() {
      // prefer a checked radio in any offer group
      var checked = $('.offer .pack-list input:checked');
      if (checked) return checked;
      var first = $('.offer .pack-list input');
      if (first) first.checked = true;
      return first;
    }

    function fillTemplate(tpl, d) {
      if (!tpl) return '';
      return tpl
        .replace(/\[name\]/g, d.name || '')
        .replace(/\[contents\]/g, d.contents || '')
        .replace(/\[price\]/g, money(d.price))
        .replace(/\[total\]/g, money(d.price))
        .replace(/\[compare\]/g, money(d.compare))
        .replace(/\[off\]/g, (d.off || '') + '%')
        .replace(/\[save\]/g, money(d.save));
    }

    function syncOffers(key) {
      var source = key
        ? $('.offer .pack-list input[value="' + key + '"]')
        : selectedInput();
      if (!source) return;
      var d = source.dataset;
      // keep every group's matching radio checked
      $$('.offer').forEach(function (o) {
        var match = o.querySelector('.pack-list input[value="' + d.value + '"]') ||
                    o.querySelector('.pack-list input[value="' + source.value + '"]');
        if (match) match.checked = true;
        set(o, '.current-price', money(d.price));
        var reg = o.querySelector('.regular-price');
        if (reg) { reg.textContent = money(d.compare); reg.setAttribute('aria-label', 'Regular price ' + money(d.compare)); }
        set(o, '.discount', (d.off || '') + '% OFF');
        set(o, '.saving', 'Save ' + money(d.save));
        set(o, '.chosen-total strong', money(d.price));
        set(o, '.chosen-total p', d.contents || '');
        var buy = o.querySelector('.buy');
        if (buy) {
          var label = d.cta || buy.getAttribute('data-base-label') || 'Add to cart';
          buy.innerHTML = '';
          buy.appendChild(document.createTextNode(label + ' '));
          var arrow = document.createElement('span'); arrow.textContent = '→';
          buy.appendChild(arrow);
        }
      });
      if (glance) {
        set(glance, 'strong', money(d.price));
        set(glance, 'del', money(d.compare));
        set(glance, 'span', (d.off || '') + '% OFF');
        set(glance, 'small', d.contents || '');
      }
      if (sticky) {
        set(sticky, '.sticky-description', d.contents || '');
        set(sticky, '.sticky-price', money(d.price));
      }
      var summaryEl = $('.selection-summary');
      if (summaryEl) {
        var tpl = (offers[0] && offers[0].dataset.summaryTpl) || '';
        var dd = { name: d.name, contents: d.contents, price: d.price, compare: d.compare, off: d.off, save: d.save };
        summaryEl.textContent = tpl ? fillTemplate(tpl, dd) : ((d.name || '') + ' · ' + (d.contents || '') + ' · ' + money(d.price));
      }
    }

    function set(root, sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; }

    if (offers.length) {
      // remember base label so a blank cta falls back gracefully
      $$('.offer .buy').forEach(function (b) { b.setAttribute('data-base-label', (b.textContent || '').replace('→', '').trim()); });
      $$('.offer .pack-list input').forEach(function (inp) {
        inp.addEventListener('change', function () { syncOffers(inp.value); });
      });
      syncOffers(null);
    }

    /* ---------- CART ---------- */
    function syncCartCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var n = c.item_count || 0;
          $$('[data-sp-cart-count]').forEach(function (b) {
            b.textContent = n;
            b.hidden = n === 0;
          });
        }).catch(function () {});
    }

    function openDrawer(data) {
      var drawer = document.querySelector(SP_CART.drawerSelector);
      if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
        try { drawer.classList.remove('is-empty'); drawer.renderContents(data); return true; } catch (e) {}
      }
      var note = document.querySelector(SP_CART.notificationSelector);
      if (note && typeof note.renderContents === 'function' && data && data.sections) {
        try { note.renderContents(data); return true; } catch (e) {}
      }
      for (var i = 0; i < SP_CART.openFallbacks.length; i++) {
        var el = document.querySelector(SP_CART.openFallbacks[i]);
        if (el) { el.click(); return true; }
      }
      return false;
    }

    var status = $('#toast');
    function say(msg) { if (status) { status.textContent = msg; status.style.display = msg ? 'block' : 'none'; if (msg) { clearTimeout(status.__t); status.__t = setTimeout(function(){ status.style.display='none'; }, 6000); } } }

    function addToCart(items, button) {
      if (button) { if (button.dataset.busy === '1') return; button.dataset.busy = '1'; button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
      say('');
      var body = { items: items, sections: SP_CART.sections, sections_url: window.location.pathname };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
      }).then(function (res) {
        if (!res.ok) {
          say((res.data && res.data.description) || 'Sorry — that option is unavailable right now.');
        } else {
          if (!openDrawer(res.data)) { window.location.href = '/cart'; return; }
          syncCartCount();
        }
      }).catch(function () {
        say('Something went wrong adding to cart. Please try again.');
      }).then(function () {
        if (button) { button.dataset.busy = '0'; button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
      });
    }

    $$('.offer .buy').forEach(function (buy) {
      buy.addEventListener('click', function () {
        var group = buy.closest('.offer');
        var input = group && (group.querySelector('.pack-list input:checked') || group.querySelector('.pack-list input'));
        if (!input) return;
        var d = input.dataset;
        if (!d.variant) {
          var url = (group && group.dataset.productUrl) || '';
          if (url) { window.location.href = url; return; }
          say('This pack isn’t linked to a product yet.');
          return;
        }
        var items = [{ id: Number(d.variant), quantity: Number(d.qty) || 1 }];
        if (d.extraVariant && Number(d.extraQty) > 0) {
          items.push({ id: Number(d.extraVariant), quantity: Number(d.extraQty) });
        }
        addToCart(items, buy);
      });
    });

    // Header bag + any CTA with [data-sp-cart]: open the drawer, never navigate to /cart via JS.
    document.addEventListener('click', function (e) {
      var bag = e.target.closest && e.target.closest('[data-sp-cart]');
      if (!bag) return;
      e.preventDefault();
      if (!openDrawer(null)) { window.location.href = '/cart'; }
    });

    // Re-sync our badge on ANY cart mutation (our adds, theme drawer removes, other apps).
    (function () {
      var origFetch = window.fetch;
      if (origFetch && !window.__spFetchPatched) {
        window.__spFetchPatched = true;
        window.fetch = function () {
          var url = arguments[0] && (arguments[0].url || arguments[0]);
          var p = origFetch.apply(this, arguments);
          if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
            p.then(function () { setTimeout(syncCartCount, 60); }).catch(function () {});
          }
          return p;
        };
      }
      ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
        document.addEventListener(ev, syncCartCount);
      });
      var bubble = null;
      for (var i = 0; i < SP_CART.themeCountSelectors.length && !bubble; i++) bubble = document.querySelector(SP_CART.themeCountSelectors[i]);
      if (bubble && 'MutationObserver' in window) {
        new MutationObserver(syncCartCount).observe(bubble, { childList: true, characterData: true, subtree: true });
      }
      syncCartCount();
    })();

    /* ---------- MODAL (shared: facts/specs, gallery zoom, customer photos) ---------- */
    var modal = $('#modal');
    var modalContent = $('#modal-content');
    var modalOrigin;
    function openModal(html) {
      if (!modal || !modalContent) return;
      modalOrigin = document.activeElement;
      modalContent.innerHTML = html;
      if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
      var c = modal.querySelector('.modal-close'); if (c) c.focus();
    }
    if (modal) {
      var closeBtn = modal.querySelector('.modal-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('close', function () { if (modalOrigin && modalOrigin.focus) modalOrigin.focus(); });
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          var r = modal.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) modal.close();
        }
      });
      modalContent.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.art-magnify') : null;
        if (!b) return;
        var zoom = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', String(zoom));
        b.textContent = zoom ? (b.getAttribute('data-off-label') || 'Fit image −') : (b.getAttribute('data-on-label') || 'Zoom in +');
        var vp = modalContent.querySelector('.art-viewport');
        if (vp) vp.classList.toggle('magnified', zoom);
      });
    }

    var factsTpl = $('#sp-facts');
    $$('.facts').forEach(function (b) {
      b.addEventListener('click', function () { if (factsTpl) openModal(factsTpl.innerHTML); });
    });

    var photosTpl = $('#sp-customer-photos');
    $$('.customer-photos').forEach(function (b) {
      b.addEventListener('click', function () { if (photosTpl) openModal(photosTpl.innerHTML); });
    });

    /* ---------- GALLERY ---------- */
    var gallery = $('.gallery');
    if (gallery) {
      var mainImg = $('#gallery-main');
      var thumbs = $$('[data-slide]', gallery);
      var count = thumbs.length;
      var current = 1;
      var jobLabel = $('#gallery-job-label');
      var countLabel = $('#gallery-count');

      function slideData(n) {
        var btn = thumbs[(n - 1 + count) % count];
        var img = btn ? btn.querySelector('img') : null;
        return {
          btn: btn,
          src: (btn && btn.getAttribute('data-full')) || (img && img.getAttribute('src')) || '',
          label: (btn && btn.getAttribute('data-label')) || (img && img.getAttribute('alt')) || ''
        };
      }
      function showSlide(n) {
        if (!count) return;
        current = ((n - 1 + count) % count) + 1;
        var d = slideData(current);
        if (mainImg && d.src) { mainImg.src = d.src; mainImg.alt = d.label; }
        if (jobLabel) jobLabel.textContent = d.label;
        if (countLabel) countLabel.textContent = current + ' / ' + count;
        thumbs.forEach(function (b, i) { b.setAttribute('aria-pressed', String(i + 1 === current)); });
      }
      thumbs.forEach(function (b, i) { b.addEventListener('click', function () { showSlide(i + 1); }); });
      var prev = $('#prev'), next = $('#next'), zoom = $('#zoom');
      if (prev) prev.addEventListener('click', function () { showSlide(current - 1); });
      if (next) next.addEventListener('click', function () { showSlide(current + 1); });
      if (zoom) zoom.addEventListener('click', function () {
        var d = slideData(current);
        openModal(
          '<h2>' + d.label + '</h2>' +
          '<div class="art-tools"><span>Gallery ' + current + ' of ' + count + '</span>' +
          '<button class="art-magnify" aria-pressed="false" data-on-label="Zoom in +" data-off-label="Fit image −">Zoom in +</button></div>' +
          '<div class="art-viewport" tabindex="0" aria-label="Gallery artwork. Zoom in and scroll to pan."><img class="modal-art" src="' + d.src + '" alt="' + d.label + '"></div>'
        );
      });
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(current - 1); }
      });
      var art = $('.gallery-art', gallery), swipeX = 0;
      if (art) {
        art.addEventListener('pointerdown', function (e) { swipeX = e.clientX; });
        art.addEventListener('pointerup', function (e) {
          var dx = e.clientX - swipeX;
          if (Math.abs(dx) > 45) showSlide(current + (dx < 0 ? 1 : -1));
        });
      }
      showSlide(1);
    }

    /* ---------- COUNTERS ---------- */
    if ('IntersectionObserver' in window) {
      var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var e = entry.target, end = parseFloat(e.dataset.count), duration = parseFloat(e.dataset.ms) || 1000;
          if (reducedMotion.matches) { e.textContent = fmtInt(end); countObserver.unobserve(e); return; }
          var start = performance.now();
          (function tick(t) {
            var k = Math.min(1, (t - start) / duration);
            e.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))).toLocaleString('en-US');
            if (k < 1) requestAnimationFrame(tick);
          })(start);
          countObserver.unobserve(e);
        });
      }, { threshold: 0.5 });
      $$('[data-count]').forEach(function (e) { countObserver.observe(e); });
    } else {
      $$('[data-count]').forEach(function (e) { e.textContent = fmtInt(e.dataset.count); });
    }

    /* ---------- STICKY OFFER (show after the hero, but hide over any buy box) ---------- */
    var hero = $('#p1') || $('.pillar.hero');
    if (sticky && 'IntersectionObserver' in window) {
      var stickyHeroPassed = false;                 // true once the hero is scrolled out of view
      var stickyHideTargets = $$('.offer');          // real buy boxes (hero + closing)
      var stickyFooter = document.querySelector('footer');
      if (stickyFooter) stickyHideTargets.push(stickyFooter);
      function stickyUpdate() {
        // Show only when we're past the hero AND no buy box / footer is on screen, so the bar
        // can never sit on top of the Add-to-Cart (the mobile overlap problem).
        var covering = stickyHideTargets.some(function (t) { return t.__onScreen; });
        sticky.classList.toggle('show', stickyHeroPassed && !covering);
      }
      if (hero) {
        new IntersectionObserver(function (e) {
          stickyHeroPassed = !e[0].isIntersecting;
          stickyUpdate();
        }, { threshold: 0.05 }).observe(hero);
      } else {
        stickyHeroPassed = true;
      }
      if (stickyHideTargets.length) {
        var stickyIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { en.target.__onScreen = en.isIntersecting; });
          stickyUpdate();
        }, { threshold: 0.01 });
        stickyHideTargets.forEach(function (t) { stickyIO.observe(t); });
      }
    }

    /* ---------- BEFORE / AFTER REVEAL ---------- */
    var reveal = $('#outcome-range');
    if (reveal) {
      reveal.addEventListener('input', function () {
        var stage = reveal.closest('.outcome-stage');
        if (stage) stage.style.setProperty('--reveal', reveal.value + '%');
      });
    }

    /* ---------- ROUTINE FILM + CHAPTERS ---------- */
    var routine = $('#routine-video');
    if (routine) {
      var film = routine.closest('.film-main');
      var filmButton = $('.film-play');
      function setRoutineState() {
        if (film) film.classList.toggle('is-playing', !routine.paused);
        if (filmButton) {
          filmButton.textContent = routine.paused ? '▶' : 'Ⅱ';
          filmButton.setAttribute('aria-label', routine.paused ? 'Play cleaning routine' : 'Pause cleaning routine');
        }
      }
      if (filmButton) filmButton.addEventListener('click', function () {
        if (routine.paused) { routine.dataset.manualPause = ''; routine.play().catch(function () {}); }
        else { routine.dataset.manualPause = 'true'; routine.pause(); }
      });
      routine.addEventListener('play', setRoutineState);
      routine.addEventListener('pause', setRoutineState);
      $$('[data-seek]').forEach(function (b) {
        b.addEventListener('click', function () {
          var seek = function () { routine.currentTime = parseFloat(b.dataset.seek) || 0; routine.dataset.manualPause = ''; routine.play().catch(function () {}); };
          if (routine.readyState >= 1) seek();
          else { routine.addEventListener('loadedmetadata', seek, { once: true }); routine.load(); }
        });
      });
      routine.addEventListener('timeupdate', function () {
        var t = routine.currentTime, all = $$('[data-seek]');
        all.forEach(function (b, i) {
          b.setAttribute('aria-pressed', String(t >= parseFloat(b.dataset.seek) && (!all[i + 1] || t < parseFloat(all[i + 1].dataset.seek))));
        });
      });
    }

    /* ---------- SCIENCE CINEMA (scenes read from [data-science] data-*) ---------- */
    var scienceStage = $('.science-cinema');
    var scienceVideo = $('.science-film');
    var sciencePoster = $('.science-poster');
    if (scienceStage && scienceVideo) {
      var scenes = $$('[data-science]').map(function (b) {
        return {
          poster: b.getAttribute('data-poster') || '',
          video: b.getAttribute('data-video') || '',
          start: parseFloat(b.getAttribute('data-start')) || 0,
          end: parseFloat(b.getAttribute('data-end')) || 0,
          title: b.getAttribute('data-title') || '',
          copy: b.getAttribute('data-copy') || ''
        };
      });
      var currentScene = 0, scienceVisible = false, sciencePaused = reducedMotion.matches;
      var scienceTitle = $('#science-title'), scienceDesc = $('#science-description');
      var scienceToggle = document.createElement('button');
      scienceToggle.className = 'media-toggle science-toggle';
      scienceToggle.type = 'button';
      scienceStage.appendChild(scienceToggle);
      function updateScienceToggle() {
        scienceToggle.textContent = sciencePaused ? '▶' : 'Ⅱ';
        scienceToggle.setAttribute('aria-label', sciencePaused ? 'Play science film' : 'Pause science film');
      }
      function setScience(n, fromPlayback) {
        if (!scenes.length) return;
        var previous = scenes[currentScene];
        currentScene = n;
        var scene = scenes[n];
        scienceStage.dataset.scene = n;
        if (scienceTitle) scienceTitle.innerHTML = scene.title;
        if (scienceDesc) scienceDesc.textContent = scene.copy;
        if (sciencePoster && scene.poster) sciencePoster.src = scene.poster;
        $$('[data-science]').forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === n)); });
        var seek = function () {
          if (!fromPlayback || (previous && previous.video !== scene.video)) { try { scienceVideo.currentTime = scene.start; } catch (e) {} }
          if (scienceVisible && !sciencePaused) scienceVideo.play().catch(function () {});
        };
        if (scene.video && scienceVideo.getAttribute('src') !== scene.video) {
          scienceVideo.src = scene.video;
          scienceVideo.addEventListener('loadedmetadata', seek, { once: true });
          scienceVideo.load();
        } else { seek(); }
        updateScienceToggle();
      }
      scienceVideo.loop = false;
      scienceVideo.hidden = false;
      scienceVideo.addEventListener('loadeddata', function () { scienceVideo.classList.add('ready'); });
      scienceVideo.addEventListener('error', function () { scienceVideo.hidden = true; });
      scienceVideo.addEventListener('timeupdate', function () {
        var scene = scenes[currentScene];
        if (scene && scene.end && scienceVideo.currentTime >= scene.end && !sciencePaused) setScience((currentScene + 1) % scenes.length, true);
      });
      scienceVideo.addEventListener('ended', function () { if (!sciencePaused) setScience((currentScene + 1) % scenes.length, true); });
      $$('[data-science]').forEach(function (b, i) { b.addEventListener('click', function () { setScience(i); }); });
      scienceToggle.addEventListener('click', function () {
        sciencePaused = !sciencePaused;
        if (sciencePaused) scienceVideo.pause(); else scienceVideo.play().catch(function () {});
        updateScienceToggle();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          scienceVisible = e[0].isIntersecting;
          if (scienceVisible && !sciencePaused) scienceVideo.play().catch(function () {}); else scienceVideo.pause();
        }, { threshold: 0.3 }).observe(scienceStage);
      }
      setScience(0);
    }

    /* ---------- SILENT LOOPING FILMS (technology, routine-detail, creator grid) ---------- */
    var videoObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !reducedMotion.matches && v.dataset.manualPause !== 'true') v.play().catch(function () {});
        else v.pause();
      });
    }, { threshold: 0.35 }) : null;

    $$('video:not(.science-film)').forEach(function (v) {
      v.muted = true; v.playsInline = true; v.removeAttribute('controls');
      if (videoObserver) videoObserver.observe(v);
      if (v === routine) return; // routine has its own big control
      var button = document.createElement('button');
      button.className = 'media-toggle'; button.type = 'button';
      button.textContent = '▶'; button.setAttribute('aria-label', 'Play video');
      if (v.parentElement) v.parentElement.appendChild(button);
      var update = function () {
        button.textContent = v.paused ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
      };
      v.addEventListener('play', update); v.addEventListener('pause', update);
      button.addEventListener('click', function () {
        if (v.paused) { v.dataset.manualPause = ''; v.play().catch(function () {}); }
        else { v.dataset.manualPause = 'true'; v.pause(); }
      });
    });

  });
})();